import * as React from "react";

import { Button } from "@/components/ui/shadcn-compat";

export default class HeaderUnLoggedUser extends React.Component {
  render() {
    return (
      <Button
        size="sm"
        color="primary"
        className="ats-link"
        icon="briefcase"
        RootComponent="a"
        href="https://hirexl.ai/"
      >
        Try ATS
      </Button>
    );
  }
}
